export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 lg:p-14 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] rounded-full bg-background-50/10 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-[250px] h-[250px] rounded-full bg-background-50/10 blur-3xl"></div>

          <div className="relative flex-1 text-center lg:text-left">
            <h2 className="text-[24px] md:text-[32px] font-heading font-extrabold text-background-50 mb-3">
              随时随地看漫画
            </h2>
            <p className="text-[14px] md:text-[15px] leading-relaxed text-background-50/90 mb-6">
              新新漫画完美适配手机与平板，竖屏滑动阅读、夜间模式、字号调节，
              通勤路上、午休间隙、睡前时光——你的漫画时光由你掌控。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="whitespace-nowrap flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-bold text-[14px] hover:bg-background-100 transition-colors cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="whitespace-nowrap flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/20 text-background-50 border-2 border-background-50/40 font-bold text-[14px] hover:bg-background-50/30 transition-colors cursor-pointer">
                <i className="ri-google-play-fill text-lg"></i>
                Google Play 下载
              </button>
            </div>
          </div>

          <div className="relative flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20mobile%20phone%20mockup%20displaying%20manga%20comic%20reading%20app%20interface%20on%20screen%2C%20warm%20coral%20and%20cream%20UI%20design%2C%20comic%20panels%20visible%2C%20floating%20phone%20on%20transparent%20background%2C%20product%20showcase%20style%2C%20minimal%20and%20elegant&width=500&height=700&seq=app-mobile-mockup&orientation=portrait"
              alt="新新漫画移动端阅读界面"
              className="w-[220px] md:w-[260px] h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}